export enum QueryKey {
  PROFILE = 'PROFILE',
  NG_WORDS = 'NG_WORDS',
  CATEGORY_APPLICATIONS = 'CATEGORY_APPLICATIONS',
  CATEGORY_APPLICATION_DETAIL = 'CATEGORY_APPLICATION_DETAIL',
  SERVICE_PACKAGES = 'SERVICE_PACKAGES',
  CATEGORY_REQUESTS = 'CATEGORY_REQUESTS',
  CATEGORY_REQUEST_DETAIL = 'CATEGORY_REQUEST_DETAIL',
  ADMIN_USERS = 'ADMIN_USERS',
  ADMIN_USER_DETAIL = 'ADMIN_USER_DETAIL',
  SKILLS = 'SKILLS',
  SCHOOLS = 'SCHOOLS',
  ADMIN_REFERRALS_SUMMARY = 'ADMIN_REFERRALS_SUMMARY',
  ADMIN_REFERRAL_DETAIL = 'ADMIN_REFERRAL_DETAIL',
}
